<template>
  <v-autocomplete
    id="municipio-select"
    v-model="filter.encontrosTipoId"
    item-text="nome"
    item-name="nome"
    item-value="encontrosTipoId"
    :items="encontrosTipo"
    :label="label ? label : 'Tipo de execução'"
    :placeholder="'Selecione o tipo'"
    :readonly="readonly"
    @change="handleChange"
  >
    <template slot="no-data"> Nenhum Tipo retornado </template>
  </v-autocomplete>
</template>

<script>
import { encontrosTipoAPI } from "@/apis";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ComboboxEncontroTipo",
  props: ["filter", "label", "readonly"],
  mounted() {
    this.loadCities();
  },
  computed: {
    ...mapGetters(["isGov"]),
  },
  watch: {
    "filter.encontrosTipoId": {
      handler(newValue) {
        // Força reatividade quando o valor muda externamente
        this.$forceUpdate();
      },
      immediate: true,
    },
  },
  methods: {
    handleChange(value) {
      // Emite evento para notificar mudança
      this.$emit("change", value);
      this.$emit("onChange", value);
    },
    loadCities() {
      encontrosTipoAPI
        .list()
        .then((resp) => {
          this.encontrosTipo = resp.data;
        })
        .catch();
    },
  },
  data() {
    return {
      encontrosTipo: [],
    };
  },
};
</script>
